import customQueryStringify from "../../helpers/queryString";
import http from "../../services/api";
import store from "../index";
import * as types from "./../types/plano";

export function LoadPlano() {
    return new Promise((resolve, reject) => { 
        store.dispatch({ type: types.PLANOS_LOADING, payload: true });
        http.get(`/api/v1/app/planos`,{ headers: { Authorization: `Bearer ${localStorage.getItem('token')}` }}).then(
            ({ data }) => {       
                store.dispatch({ type: types.PLANOS_SET, payload: data });
                store.dispatch({ type: types.PLANOS_LOADING, payload: false });
                resolve(data);
            },
            (e) => {
                store.dispatch({ type: types.PLANOS_LOADING, payload: false });
                reject();
            }   
        );
    });
};



export function LoadPlanoCliente(qryStr) {
    const _qry = customQueryStringify(qryStr);
  
    store.dispatch({ type: types.CHANGE_PLANO_CLIENTE_LOADING, payload: true });
    return new Promise((resolve, reject) => {
      http
        .get(`/api/v2/app/cliente?${_qry}`)
        .then((response) => {
          store.dispatch([
            { type: types.CHANGE_PLANO_CLIENTE_LOADING, payload: false },
            { type: types.CHANGE_CLIENTE_PLANOS, payload: response.data.plano },
          ]);
          resolve(response.data);
        })
        .catch((e) => {
          store.dispatch({
            type: types.CHANGE_PLANO_CLIENTE_LOADING,
            payload: false,
          });
          reject(
            e.response?.data ? e.response?.data : "Não foi possível prosseguir"
          );
        });
    });
  }

/**
 * @param {number} id 
 * @param {AbortController} [abortController] 
 */
export async function FindPlanoByID(id, abortController = undefined) {
  return await http
    .get(`/api/v2/app/plano/${id}?`, { signal: abortController?.signal })
    .then((response) => response.data)
    .catch((error) => {
      if (error?.response?.data) {
        return Promise.reject({
          ...error.response.data,
          message: error.response.data?.message || "Erro ao buscar o plano",
          status: error?.response?.status,
        });
      }

      return Promise.reject({
        code: error?.code,
        message: "Erro ao buscar o plano",
      });
    });
}